var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.records && _vm.records.length > 0
    ? _c("div", { staticClass: "kanban-summary" }, [
        _c(
          "div",
          { staticClass: "dropdown-summary" },
          _vm._l(_vm.getDropdownDistribution(), function (dist) {
            return _c("div", {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.getDropdownTooltip(dist) },
                  expression: "{ content: getDropdownTooltip(dist) }",
                },
              ],
              key: dist.value,
              staticClass: "summary-option-chip",
              style: {
                backgroundColor: dist.color,
                flexGrow: dist.flexValue,
              },
            })
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }